<ng-container *ngFor="let modal of modals; trackBy: itemTrackBy">
  <app-block-factory
    [blockId]="modal.block"
    [injectData]="getModalData(modal)"
  ></app-block-factory>
</ng-container>
